export const householdKeys = {
  all: () => ['households'] as const,
  lists: () => [...householdKeys.all(), 'list'] as const,
  list: (personId?: string) => [...householdKeys.lists(), { personId }] as const,
  detail: (id: string) => [...householdKeys.all(), 'detail', id] as const,
}
